import React from "react"
import { Col, Row } from "react-bootstrap"
import InfiniteScroll from "react-infinite-scroll-component"

import { InfiniteScrollLoader, OhCard } from "components"

const OrdersList = props => {
  const {
    hasMore,
    skip,
    loadMore,
    orders,
    setOrders
  } = props
  
  return (
    <InfiniteScroll
      hasMore={hasMore}
      dataLength={skip}
      next={loadMore}
      loader={<InfiniteScrollLoader />}
      scrollThreshold="100px"
    >
      <Row>
        {orders.map(order => (
          <Col
            key={order._id}
            md={6} lg={4}
          >
            <OhCard
              order={order}
              setOrders={setOrders}
            />
          </Col>
        ))}
      </Row>
    </InfiniteScroll>
  )
}

export default OrdersList